/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum BookShipmentStrategyType {
  Automatic = "Automatic",
  Email = "Email",
  Manual = "Manual",
}

export function instanceOfBookShipmentStrategyType(value: any): boolean {
  for (const key in BookShipmentStrategyType) {
    if (Object.prototype.hasOwnProperty.call(BookShipmentStrategyType, key)) {
      if (
        BookShipmentStrategyType[
          key as keyof typeof BookShipmentStrategyType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function BookShipmentStrategyTypeFromJSON(
  json: any,
): BookShipmentStrategyType {
  return BookShipmentStrategyTypeFromJSONTyped(json, false);
}

export function BookShipmentStrategyTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BookShipmentStrategyType {
  return json as BookShipmentStrategyType;
}

export function BookShipmentStrategyTypeToJSON(
  value?: BookShipmentStrategyType | null,
): any {
  return value as any;
}

export function BookShipmentStrategyTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): BookShipmentStrategyType {
  return value as BookShipmentStrategyType;
}
